import { cloneDeep } from 'lodash';

const state = {
  list: [],
  template: {},
  edit_template: {},
  filter: { page: 1 },
  missing: [],
  copy: [],
  replace: [],
  total: 0
};

const getters = {
  list: (state) => {
    return state.list || [];
  },
  template: (state) => {
    return state.template || {};
  },
  edit_template: (state) => {
    return state.edit_template || {};
  },
  filter: (state) => {
    return state.filter || {};
  },
  missing: (state) => {
    return state.missing || [];
  },
  copy: (state) => {
    return state.copy || [];
  },
  replace: (state) => {
    return state.replace || [];
  },
  total: (state) => {
    return state.total || 0;
  }
};

const mutations = {
  SET_LIST(state, list) {
    state.list = list;
  },
  SET_TEMPLATE(state, item) {
    state.template = cloneDeep(item);
    state.edit_template = cloneDeep(item);
    const index = state.list.findIndex((x) => x.id === item.id);
    if (index >= 0) {
      this._vm.$set(state.list, index, Object.assign(state.list[index], cloneDeep(item)));
    } else {
      state.list.splice(0, 0, cloneDeep(item));
    }
  },
  EDIT_TEMPLATE(state, item) {
    state.edit_template = cloneDeep(item);
  },
  DELETE_TEMPLATE(state, id) {
    state.template = {};
    state.edit_template = {};
    const index = state.list.findIndex((x) => x.id === id);
    if (index >= 0) {
      state.list.splice(index, 1);
    }
  },
  SET_FILTER(state, item) {
    state.filter = item;
  },
  SET_MISSING(state, item) {
    state.missing = item;
  },
  SET_COPY(state, item) {
    state.copy = item;
  },
  DELETE_COPY(state, ids) {
    state.copy = state.copy.filter((x) => !ids.includes(x.id));
  },
  SET_REPLACE(state, item) {
    state.replace = item;
  },
  DELETE_REPLACE(state, id) {
    state.replace = state.replace.filter((x) => x.id !== id);
  },
  SET_TOTAL(state, total) {
    state.total = total;
  }
};

const actions = {
  load({ commit }, filter) {
    return new Promise((resolve, reject) => {
      if (!filter.page) {
        filter.page = 1;
      }
      this._vm.$http
        .post('templates/getAll', filter)
        .then((response) => {
          commit('SET_LIST', response.data.templates);
          commit('SET_TOTAL', response.data.total);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  clear({ commit }) {
    return new Promise((resolve, reject) => {
      commit('SET_LIST', []);
      resolve();
    });
  },
  loadTasks({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('templates/getTasks')
        .then((response) => {
          commit('SET_LIST', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  loadMissing({ commit }, filter) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('templates/getMissing', filter)
        .then((response) => {
          commit('SET_MISSING', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  loadCopy({ commit }, filter) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('templates/getResize', filter)
        .then((response) => {
          commit('SET_COPY', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  loadReplace({ commit }, filter) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('templates/getReplace', filter)
        .then((response) => {
          commit('SET_REPLACE', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  edit({ commit }, template) {
    commit('EDIT_TEMPLATE', template);
  },
  get({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`templates/get?id=${id}`)
        .then((response) => {
          commit('SET_TEMPLATE', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  create({ commit }, template) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('templates/create', template)
        .then((response) => {
          for (const template of response.data) {
            commit('SET_TEMPLATE', template);
          }
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updateDetails({ commit }, template) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('templates/update', template)
        .then((response) => {
          commit('SET_TEMPLATE', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  updatePublished({ commit }, template) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`templates/updatePublished?templateId=${template.id}&published=${template.published}`)
        .then((response) => {
          commit('SET_TEMPLATE', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  publishBulk({ commit }, ids) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('templates/publishBulk', ids)
        .then((response) => {
          for (const template of response.data.templates) {
            commit('SET_TEMPLATE', template);
          }
          resolve(response.data.skipped || []);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  generateImages({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`templates/generateImages?templateId=${id}`)
        .then((response) => {
          commit('SET_TEMPLATE', response.data);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  delete({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`templates/delete?templateId=${id}`)
        .then(() => {
          commit('DELETE_TEMPLATE', id);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  copy({ commit }, req) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('templates/copy', req)
        .then(() => {
          commit('DELETE_COPY', req.templateIds);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  copyDefaults({ commit }, templates) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('templates/copyDefaults', templates)
        .then(() => {
          commit(
            'DELETE_COPY',
            templates.map((x) => x.id)
          );
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  ignoreResize({ commit }, templateIds) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('templates/ignoreResize', { templateIds })
        .then(() => {
          commit('DELETE_COPY', templateIds);
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  filter({ commit }, item) {
    commit('SET_FILTER', item);
  },
  // eslint-disable-next-line no-empty-pattern
  getEditorUrl({}, templateId) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`templates/getEditorUrl?templateId=${templateId}`)
        .then((response) => {
          resolve(response.data.url);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  getSuggestedName({}, template) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post('templates/getSuggestedName', template)
        .then((response) => {
          resolve(response.data.name);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
